import { AdminUpdateAreaCase } from './domain/useCases/AdminUpdateAreaCase'
import { CreateAreaCase } from './domain/useCases/CreateAreaCase'
import { CreateAssignAttachmentCase } from './domain/useCases/CreateAssignAttachmentCase'
import { CreateAssignPriorityCase } from './domain/useCases/CreateAssignPriorityCase'
import { CreateAssignResponsibilityCase } from './domain/useCases/CreateAssignResponsibilityCase'
import { CreateNotificationAreaAssociationCase } from './domain/useCases/CreateNotificationAreaAssociationCase'
import { CreateSubAreaCase } from './domain/useCases/CreateSubAreaCase'
import { CreateTicketEvaluationCase } from './domain/useCases/CreateTicketEvaluationCase'
import { CreateTicketCase } from './domain/useCases/CreateTicketsCase'
import { CreateTicketStatusCase } from './domain/useCases/CreateTicketStatusCase'
import { DeleteAreaIdCase } from './domain/useCases/DeleteAreaIdCase'
import { DeleteNotificationAreaAssociationCase } from './domain/useCases/DeleteNotificationAreaAssociationCase'
import { EditNotificationAreaAssociationCase } from './domain/useCases/EditNotificationAreaAssociationCase'
import { GetTicketDetailCase } from './domain/useCases/GetTicketDetailCase'
import { ListAgentsAndResponsiblesByAreaCase } from './domain/useCases/ListAgentsAndResponsiblesByAreaCase'
import { listAllResponsibleTheAreaCase } from './domain/useCases/ListAllResponsibleTheAreaCase'
import { ListAreaByIdCase } from './domain/useCases/ListAreaByIdCase'
import { ListAreaPrioritiesCase } from './domain/useCases/ListAreaPrioritiesCase'
import { ListAreaResponsibleCase } from './domain/useCases/ListAreaResponsibleCase'
import { ListAreasCase } from './domain/useCases/ListAreasCase'
import { ListCompletedTicketsByAreaCase } from './domain/useCases/ListCompletedTicketsByAreaCase'
import { ListFilterTicketCase } from './domain/useCases/ListFilterTicketCase'
import { ListIndicatorsMetricsTmaCase } from './domain/useCases/ListIndicatorsMetricsTmaCase'
import { ListIndicatorsMetricsTmeCase } from './domain/useCases/ListIndicatorsMetricsTmeCase'
import { ListNameAreaCase } from './domain/useCases/ListNameAreaCase'
import { ListNotificationsAreasCase } from './domain/useCases/ListNotificationsAreasCase'
import { ListOperationalAreasCase } from './domain/useCases/ListOperationalAreasCase'
import { ListPatientTicketDateCase } from './domain/useCases/ListPatientTicketDateCase'
import { ListPatientTicketsCase } from './domain/useCases/ListPatientTicketsCase'
import { ListPersonaTicketAreaCase } from './domain/useCases/ListPersonaTicketAreaCase'
import { ListPersonaTicketsCase } from './domain/useCases/ListPersonaTicketsCase'
import { ListResponsibleTicketIndicatorsCase } from './domain/useCases/ListResponsibleTicketIndicatorsCase'
import { ListTicketDateCase } from './domain/useCases/ListTicketDateCase'
import { ListTicketForAssignAttachmentCase } from './domain/useCases/ListTicketForAssignAttachmentCase'
import { ListTicketIndicatorsCase } from './domain/useCases/ListTicketIndicatorsCase'
import { ListTicketsAreaCase } from './domain/useCases/ListTicketsAreaCase'
import { ListTicketCase } from './domain/useCases/ListTicketsCase'
import { OperationalUpdateAreaCase } from './domain/useCases/OperationalUpdateAreaCase'
import { OperatorsListCase } from './domain/useCases/OperatorsListCase'
import { UpdateAreaPriorityCase } from './domain/useCases/UpdateAreaPriorityCase'
import { UpdateSubAreaCase } from './domain/useCases/UpdateSubAreaCase'
import { TicketDatasource } from './external/datasources/TicketDatasource'
import { ticketRepository } from './infra/repositories/TicketRepository'

const listTicket = ListTicketCase(ticketRepository(TicketDatasource))
const createTicket = CreateTicketCase(ticketRepository(TicketDatasource))
const ticketDetail = GetTicketDetailCase(ticketRepository(TicketDatasource))
const createAssignResponsibility = CreateAssignResponsibilityCase(
  ticketRepository(TicketDatasource)
)

const createAssignPriority = CreateAssignPriorityCase(
  ticketRepository(TicketDatasource)
)
const createTicketEvaluation = CreateTicketEvaluationCase(
  ticketRepository(TicketDatasource)
)
const createTicketStatus = CreateTicketStatusCase(
  ticketRepository(TicketDatasource)
)

const createAssignAttachment = CreateAssignAttachmentCase(
  ticketRepository(TicketDatasource)
)
const listTicketForAssignAttachment = ListTicketForAssignAttachmentCase(
  ticketRepository(TicketDatasource)
)

const listTicketsPersona = ListPersonaTicketsCase(
  ticketRepository(TicketDatasource)
)

const listTicketsPatient = ListPatientTicketsCase(
  ticketRepository(TicketDatasource)
)

const listTicketsArea = ListTicketsAreaCase(ticketRepository(TicketDatasource))

const listCompletedTicketsByArea = ListCompletedTicketsByAreaCase(
  ticketRepository(TicketDatasource)
)

const listResponsibleTicketIndicators = ListResponsibleTicketIndicatorsCase(
  ticketRepository(TicketDatasource)
)
const listTicketIndicators = ListTicketIndicatorsCase(
  ticketRepository(TicketDatasource)
)
const updateSubArea = UpdateSubAreaCase(ticketRepository(TicketDatasource))
const listAreaPriorities = ListAreaPrioritiesCase(
  ticketRepository(TicketDatasource)
)
const listAreas = ListAreasCase(ticketRepository(TicketDatasource))

const updateAreaPriority = UpdateAreaPriorityCase(
  ticketRepository(TicketDatasource)
)

const createArea = CreateAreaCase(ticketRepository(TicketDatasource))

const createSubArea = CreateSubAreaCase(ticketRepository(TicketDatasource))

const listAreaResponsible = ListAreaResponsibleCase(
  ticketRepository(TicketDatasource)
)

const listAreaById = ListAreaByIdCase(ticketRepository(TicketDatasource))

const listTicketDate = ListTicketDateCase(ticketRepository(TicketDatasource))

const listPatientTicketDate = ListPatientTicketDateCase(
  ticketRepository(TicketDatasource)
)

const listPersonaTicketArea = ListPersonaTicketAreaCase(
  ticketRepository(TicketDatasource)
)

const listNotificationsAreas = ListNotificationsAreasCase(
  ticketRepository(TicketDatasource)
)

const createNotificationAreaAssociation = CreateNotificationAreaAssociationCase(
  ticketRepository(TicketDatasource)
)

const deleteNotificationAreaAssociation = DeleteNotificationAreaAssociationCase(
  ticketRepository(TicketDatasource)
)

const editNotificationAreaAssociation = EditNotificationAreaAssociationCase(
  ticketRepository(TicketDatasource)
)

const listOperationalAreas = ListOperationalAreasCase(
  ticketRepository(TicketDatasource)
)

const adminUpdateArea = AdminUpdateAreaCase(ticketRepository(TicketDatasource))

const operationalUpdateArea = OperationalUpdateAreaCase(
  ticketRepository(TicketDatasource)
)

const deleteAreaId = DeleteAreaIdCase(ticketRepository(TicketDatasource))

const operationalList = OperatorsListCase(ticketRepository(TicketDatasource))

const listNameArea = ListNameAreaCase(ticketRepository(TicketDatasource))

const listFilterTicket = ListFilterTicketCase(
  ticketRepository(TicketDatasource)
)

const listAllResponsibleTheArea = listAllResponsibleTheAreaCase(
  ticketRepository(TicketDatasource)
)

const listIndicatorsMetricsTma = ListIndicatorsMetricsTmaCase(
  ticketRepository(TicketDatasource)
)

const listIndicatorsMetricsTme = ListIndicatorsMetricsTmeCase(
  ticketRepository(TicketDatasource)
)

const listAgentsAndResponsiblesByArea = ListAgentsAndResponsiblesByAreaCase(
  ticketRepository(TicketDatasource)
)

export const ticketInstance = {
  listTicket,
  createTicket,
  ticketDetail,
  createAssignResponsibility,
  createAssignPriority,
  createTicketEvaluation,
  createTicketStatus,
  createAssignAttachment,
  listTicketForAssignAttachment,
  listTicketsPatient,
  listTicketsPersona,
  listTicketsArea,
  listCompletedTicketsByArea,
  listResponsibleTicketIndicators,
  listTicketIndicators,
  listAreas,
  updateSubArea,
  listAreaPriorities,
  updateAreaPriority,
  createArea,
  createSubArea,
  listAreaResponsible,
  listAreaById,
  listTicketDate,
  listPatientTicketDate,
  listPersonaTicketArea,
  listNotificationsAreas,
  createNotificationAreaAssociation,
  deleteNotificationAreaAssociation,
  editNotificationAreaAssociation,
  listOperationalAreas,
  adminUpdateArea,
  operationalUpdateArea,
  deleteAreaId,
  operationalList,
  listNameArea,
  listFilterTicket,
  listAllResponsibleTheArea,
  listIndicatorsMetricsTma,
  listIndicatorsMetricsTme,
  listAgentsAndResponsiblesByArea
}
